import * as WormholeAction from './src/Action'
import * as wormholeActions from './src/actions'
import { ViewConstants } from './src/actions/views/viewConstants'
import EntityNames from './src/helpers/EntityNames'
import { deserializeJson } from './src/jsonApiDeserializer'
import { ReduxUpdateQueue } from './src/jsonApiDeserializer/reduxUpdateQueue'
import * as jsonApiParser from './src/jsonApiParser'
import decorators, {
  channelNameMaps,
  gemChannelNameMaps,
  decorateServiceName,
} from './src/jsonApiParser/decorators'
import registerAllSagas from './src/sagas'
import { getters, selectorHelpers, selectors } from './src/selectors'

export * from './src/Action'
export * from './src/actions'
export * from './src/jsonApiParser'

const Action = {
  Action: WormholeAction,
  ...WormholeAction,
}
const actions = {
  actions: wormholeActions,
  ...wormholeActions,
}
const parser = {
  parser: jsonApiParser,
  ...jsonApiParser,
}

export {
  Action,
  actions,
  channelNameMaps,
  gemChannelNameMaps,
  decorateServiceName,
  decorators,
  deserializeJson,
  EntityNames,
  getters,
  parser,
  ReduxUpdateQueue,
  registerAllSagas,
  selectorHelpers,
  selectors,
  ViewConstants,
}
